export const getFillColorFunctionMapping = {
  default_point: (v) => {
    return [48, 79, 254];
  },
  default_polygon: (v) => {
    return [48, 79, 254];
  },
  secondary_point: (v) => {
    return [0, 0, 0];
  },
  secondary_polygon: (v) => {
    return [0, 0, 0];
  },
  ce_projects_fill: (v) => {
    return [255, 165, 0];
  },
  ce_location_fill: (v) => {
    return [0, 184, 148];
  },
};

export const getPointRadiusFunctionMapping = {
  default_point: (v) => {
    return 5;
  },
  default_polygon: (v) => {
    return 5;
  },
  secondary_point: (v, zoom) => {
    if (zoom >= 14) {
      return 12;
    }
    if (zoom >= 8) {
      return 9;
    }
    return 7;
  },
  secondary_polygon: (v) => {
    return 5;
  },
};

export const getLineColorFunctionMapping = {
  default_line: (v) => {
    return [48, 79, 254];
  },
  secondary_line: (v) => {
    return [0, 0, 0];
  },
  ce_projects_line: (v) => {
    return [255, 165, 0];
  },
  ce_location_line: (v) => {
    return [0, 184, 148];
  },
};

export const getLineWidthFunctionMapping = {
  default_line: (v) => {
    return 4;
  },
  secondary_line: (v, zoom) => {
    if (zoom >= 14) {
      return 8;
    }
    if (zoom >= 8) {
      return 6;
    }
    return 5;
  },
};

const uiReferenceMapping = [
  {
    id: 'default_line',
    attr: {
      title: 'Data',
      visible: true,
      opacity: 0.95,
      legend: {},
      getLineColor: 'default_line',
      getLineWidth: 'default_line',
    },
  },
  {
    id: 'default_point',
    attr: {
      title: 'Data',
      visible: true,
      opacity: 0.95,
      legend: {},
      getFillColor: 'default_point',
      getPointRadius: 'default_point',
    },
  },
  {
    id: 'default_polygon',
    attr: {
      title: 'Data',
      visible: true,
      opacity: 0.95,
      legend: {},
      getFillColor: 'default_polygon',
      getPointRadius: 'default_polygon',
    },
  },
  {
    id: 'secondary_line',
    attr: {
      title: 'Data',
      visible: true,
      opacity: 0.95,
      legend: {},
      getLineColor: 'secondary_line',
      getLineWidth: 'secondary_line',
    },
  },
  {
    id: 'secondary_point',
    attr: {
      title: 'Data',
      visible: true,
      opacity: 0.95,
      legend: {},
      getFillColor: 'secondary_point',
      getPointRadius: 'secondary_point',
    },
  },
  {
    id: 'secondary_polygon',
    attr: {
      title: 'Data',
      visible: true,
      opacity: 0.95,
      legend: {},
      getFillColor: 'secondary_polygon',
      getPointRadius: 'secondary_polygon',
    },
  },
];

export const getAttributesFromId = (id) => {
  let ans = {};
  uiReferenceMapping.forEach((map) => {
    if (map.id === id) {
      ans = map.attr;
    }
  });
  return ans;
};
